import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material'
import { LandingBlock } from '../components/LandingBlock'
import { landingBoxes } from '../constants'
import { NavLink } from 'react-router'

const ProductImage = () => (
	<Box
		component="img"
		src="https://static.wixstatic.com/media/1b43b4_d299df43662a4787838f5994390f129f~mv2.png"
		sx={{
			position: {
				md: 'absolute'
			},
			width: {
				xs: '100%',
				md: 300
			},
			mt: {
				xs: '30px',
				md: 0
			},
			transform: {
				md: 'translateY(100px)'
			}
		}}
	/>
)

export default function Landing() {
	return (
		<Container maxWidth="lg">
			<ProductImage />
			<Stack
				sx={{
					pt: {
						md: 12
					},
					pb: 6
				}}
				gap={{
					xs: 4,
					md: 12
				}}
			>
				<Stack justifyContent="center" textAlign="center" gap={3}>
					<Typography variant="h1">Better food starts here.</Typography>
					<Typography variant="body1" sx={{ maxWidth: 400, margin: '0em auto' }}>
						Just a couple questions way from recommending the perfect meal plan for your dog.
					</Typography>
					<Typography variant="caption">Only takes ~2 minutes per dog.</Typography>
				</Stack>

				<Button
					component={NavLink}
					to="/me"
					variant="contained"
					color="primary"
					size="large"
					sx={{
						alignSelf: 'center',
						mb: {
							xs: 8,
							md: 0
						}
					}}
				>
					Continue
				</Button>

				<Grid
					container
					spacing={{
						xs: 12,
						md: 3
					}}
					textAlign={'center'}
				>
					{landingBoxes.map((box: any, i: number) => (
						<Grid item xs={12} md={4} key={i}>
							<LandingBlock {...box} />
						</Grid>
					))}
				</Grid>
			</Stack>
		</Container>
	)
}
